import { Outlet } from "react-router";

export function TenantLayout() {
  return <Outlet />;
}
